import React from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";

const blogPosts = [
  {
    id: "manager-massage-impact",
    date: "2025-06-10",
    title: {
      hu: "Irodai masszázs hatása a teljesítményre",
    },
    content: {
      hu: (
        <>
          <img
            src="/articleImages/iroda.jpg"
            alt="Professzionális irodai masszázs"
            className="img-fluid rounded mb-4"
          />
          <p className="text-muted mb-4 text-center">
            <small>Vállalati masszázs szolgáltatás (Forrás: Unsplash)</small>
          </p>

          <h2>Az irodai masszázs előnyei</h2>
          <p>
            A modernebb vállalatok a masszázst is bevonták a jóléti programokba,
            és az eredmények meggyőzőek:
          </p>
          <ul>
            <li>
              <strong>28%-os csökkenés az izomfeszültségben</strong> (Journal of
              Occupational Health)
            </li>
            <li>
              <strong>19%-os koncentrációjavulás</strong> (Corporate Wellness
              Study 2024)
            </li>
            <li>
              <strong>42%-uk jelentett jobb alvásminőséget</strong>
            </li>
          </ul>

          <h2>Vezetői masszázs technikák</h2>
          <div className="row">
            <div className="col-md-6 mb-4">
              <h4>1. Ülő akupresszúra</h4>
              <p>
                10-15 perces nyak-váll-hát kezelés, tökéletes gyors felüdülésre.
              </p>
            </div>
            <div className="col-md-6 mb-4">
              <h4>2. Stresszoldó pontok</h4>
              <p>Speciális technikák a kéz, fejbőr és halánték területén.</p>
            </div>
          </div>

          <div className="alert alert-info mt-4">
            <strong>Pro tipp:</strong> Kombináld ergonómiai elemzéssel a
            maximális hatásért.
          </div>
        </>
      ),
    },
  },
  {
    id: "medical-pedicure-benefits",
    date: "2025-06-15",
    title: {
      hu: "Gyógypedikűr: Több, mint egyszerű lábápolás",
    },
    content: {
      hu: (
        <>
          <img
            src="/articleImages/feet-5893684_1280.jpg"
            alt="Professional medical pedicure"
            className="img-fluid rounded mb-4"
          />
          <p className="text-muted mb-4 text-center">
            <small>Steril gyógypedikűr kezelés (Forrás: Unsplash)</small>
          </p>

          <h2>A gyógypedikűr létfontossága</h2>
          <p>
            A hagyományos pedikűrrel ellentétben a podológus által végzett
            gyógypedikűr komoly lábegészségügyi problémákra fókuszál:
          </p>
          <ul>
            <li>
              <strong>78%-kal csökkenti a gombásfertőzések kockázatát</strong>{" "}
              (Podiatry Today)
            </li>
            <li>
              <strong>65%-kal kevesebb diabéteszes lábprobléma</strong>
            </li>
            <li>
              <strong>92%-ban korrigálja a becsípődött köröm eseteit</strong>{" "}
              műtét nélkül
            </li>
          </ul>

          <h2>Különbségek a szokásos pedikűrhöz képest</h2>
          <div className="row">
            <div className="col-md-6 mb-4">
              <h4>1. Orvosi felszerelés</h4>
              <p>
                Steril eszközök és orvosi minőségű fertőtlenítők biztosítják a
                teljes biztonságot.
              </p>
            </div>
            <div className="col-md-6 mb-4">
              <h4>2. Terápiás megközelítés</h4>
              <p>
                A megrögzött tyúkszemek, nattszövet elváltozások és
                körömproblémák precíz kezelése.
              </p>
            </div>
          </div>

          <div className="alert alert-warning mt-4">
            <strong>Fontos:</strong> Cukorbetegeknek és keringési problémásoknak
            4-6 hetente ajánlott.
          </div>
        </>
      ),
    },
  },
  {
    id: "reflexology-therapy",
    date: "2025-06-29",
    title: {
      hu: "Gyógypedikűr: Több, mint egyszerű lábápolás",
    },
    content: {
      hu: (
        <>
          <img
            src="/articleImages/TalpReflex.jpg"
            alt="Talpreflexológiai kezelés"
            className="img-fluid rounded mb-4"
          />
          <p className="text-muted mb-4 text-center">
            <small>
              Talpreflexológiai kezelés egyensúlyteremtés céljából (Forrás:
              Unsplash)
            </small>
          </p>

          <h2>Talpreflexológia: a belső egyensúly lábon keresztül</h2>
          <p>
            A reflexológia ősi módszer, amely szerint a talpon található zónák
            kapcsolatban állnak a test szerveivel. A megfelelő pontok
            masszírozásával serkenthető a szervek működése, csökken a stressz és
            javul az általános közérzet.
          </p>
          <ul>
            <li>
              <strong>61%-os stresszcsökkenés</strong> már 2-3 alkalom után
              (Reflexology Insights 2023)
            </li>
            <li>
              <strong>48%-kal enyhébb emésztési panaszok</strong> 4 hét kezelés
              után
            </li>
            <li>
              <strong>Javuló alvásminőség és energiaszint</strong> a legtöbb
              páciensnél
            </li>
          </ul>

          <h2>Reflexzónák a gyakorlatban</h2>
          <div className="row">
            <div className="col-md-6 mb-4">
              <h4>1. Fej és idegrendszer</h4>
              <p>
                A nagylábujjon található pontok stimulálása csökkentheti a
                fejfájást, javíthatja a koncentrációt és elősegítheti a mentális
                egyensúlyt.
              </p>
            </div>
            <div className="col-md-6 mb-4">
              <h4>2. Emésztő- és kiválasztórendszer</h4>
              <p>
                A talpközép és sarokrész kezelése támogatja a bélműködést,
                segíti a méregtelenítést, és enyhítheti a puffadást vagy
                székrekedést.
              </p>
            </div>
          </div>

          <div className="alert alert-warning mt-4">
            <strong>Pro tipp:</strong> A reflexzóna-masszázst hetente 1x
            alkalmazva megelőzhetők a krónikus panaszok, és hosszú távon is
            fenntartható a testi-lelki egyensúly.
          </div>
        </>
      ),
    },
  },
  {
    id: "lymphatic-massage",
    date: "2025-06-27",
    title: {
      hu: "Manuális nyirokdrenázs szakszerű kivitelezése (Forrás: Unsplash)",
    },
    content: {
      hu: (
        <>
          <img
            src="/articleImages/nyirok.jpg"
            alt="Nyirokmasszázs kezelés"
            className="img-fluid rounded mb-4"
          />
          <p className="text-muted mb-4 text-center">
            <small>
              Manuális nyirokdrenázs szakszerű kivitelezése (Forrás: Unsplash)
            </small>
          </p>

          <h2>Nyirokmasszázs: a méregtelenítés természetes útja</h2>
          <p>
            A nyirokrendszer az immunrendszer egyik kulcseleme, amely segít
            eltávolítani a méreganyagokat és fenntartani a szervezet
            egyensúlyát. A nyirokmasszázs (más néven manuális nyirokdrenázs)
            kifejezetten ezt a rendszert aktiválja, finom, ritmikus
            mozdulatokkal.
          </p>
          <ul>
            <li>
              <strong>82%-os ödémacsökkenés</strong> nyirokpangásos pácienseknél
              (LymphCare Study 2023)
            </li>
            <li>
              <strong>Gyorsabb regeneráció</strong> műtétek és sérülések után
            </li>
            <li>
              <strong>Javuló immunválasz</strong> és csökkenő gyulladásszint
            </li>
          </ul>

          <h2>Miben más ez, mint a klasszikus masszázs?</h2>
          <div className="row">
            <div className="col-md-6 mb-4">
              <h4>1. Finom, lassú mozdulatok</h4>
              <p>
                Nem izomlazító technika – célja a nyirokfolyadék kíméletes
                terelése a nyirokcsomók felé.
              </p>
            </div>
            <div className="col-md-6 mb-4">
              <h4>2. Célzott terápia</h4>
              <p>
                Hatékony vízvisszatartás, cellulit, allergiás tünetek és
                krónikus gyulladások kezelésére.
              </p>
            </div>
          </div>

          <div className="alert alert-warning mt-4">
            <strong>Fontos:</strong> Akut fertőzés, láz vagy trombózis esetén
            nem alkalmazható – mindig konzultálj szakemberrel!
          </div>
        </>
      ),
    },
  },
  {
    id: "medical-pedicure",
    date: "2025-06-15",
    title: {
      hu: "Gyógypedikűr – nem csak esztétika, hanem megelőzés is",
    },
    content: {
      hu: (
        <>
          <img
            src="/articleImages/medical-pedicure-.jpg"
            alt="Gyógypedikűr kezelés közben"
            className="img-fluid rounded mb-4"
          />
          <p className="text-muted mb-4 text-center">
            <small>Egészségközpontú lábápolás a III. kerületben</small>
          </p>

          <h2>Miért fontos a gyógypedikűr?</h2>
          <p>
            A lábainkat nap mint nap terheljük, mégis gyakran megfeledkezünk
            róluk. A gyógypedikűr nem csupán szépségápolás, hanem megelőzés is –
            különösen azok számára, akik bőrkeményedéssel, tyúkszemmel vagy
            egyéb elváltozással küzdenek.
          </p>

          <h2>Miben különbözik a hagyományos pedikűrtől?</h2>
          <ul>
            <li>
              A hagyományos pedikűr főként esztétikai célokat szolgál
              (körömvágás, lakkozás).
            </li>
            <li>
              A gyógypedikűr gyógyászati szemléletű kezelés, szakképzett
              lábápolóval.
            </li>
            <li>
              Célja a lábproblémák (pl. benőtt köröm, gombás fertőzések)
              szakszerű kezelése.
            </li>
          </ul>

          <h2>Milyen problémákra nyújt megoldást?</h2>
          <p>A gyógypedikűr különösen hasznos a következő esetekben:</p>
          <ul>
            <li>Repedezett sarok, bőrkeményedés</li>
            <li>Tyúkszem, nyomásponti fájdalmak</li>
            <li>Benőtt vagy deformált körmök</li>
            <li>Gombás fertőzések</li>
            <li>Diabéteszes láb</li>
          </ul>

          <h2>Kiknek ajánlott?</h2>
          <div className="row">
            <div className="col-md-6 mb-3">
              <p>
                Azoknak, akik állómunkát végeznek (fodrász, bolti dolgozó),
                idősebbeknek, várandós nőknek, illetve cukorbetegeknek.
              </p>
            </div>
            <div className="col-md-6 mb-3">
              <p>
                A rendszeres lábápolás nem luxus, hanem szükséglet – különösen
                ha már fennállnak problémák.
              </p>
            </div>
          </div>

          <div className="alert alert-info mt-4">
            <strong>Tipp:</strong> A kezelés előtti állapotfelmérés növeli a
            hatékonyságot, és segít a személyre szabott gondoskodásban.
          </div>

          <h2>Gyógypedikűr a Csillag Masszázsnál</h2>
          <p>
            A kezeléseket szakképzett gyógypedikűrös végzi Budapesten, a III.
            kerületben. Igény szerint háznál is elérhető. A hangsúly nálunk az
            egészséges, fájdalommentes járáson van.
          </p>
          <ul>
            <li>📍 Cím: Delice Éden Szépségszalon</li>
            <li>📞 Telefon: +36 70 554 1606</li>
            <li>
              🌐{" "}
              <a href="https://janoseszter.com/hu/kapcsolat">
                Kapcsolatfelvétel itt
              </a>
            </li>
          </ul>
        </>
      ),
    },
  },
  {
    id: "massage-pedicure-foot",
    date: "2025-10-19",
    title: {
      hu: "Több, mint pedikűr: A masszázs gyógyereje a lábadnak",
    },
    content: {
      hu: (
        <>
          <img
            src="/articleImages/feet-5893684_1280.jpg"
            alt="Professional medical pedicure"
            className="img-fluid rounded mb-4"
          />

          <h2>Bevezetés:</h2>
          <p>
            Egy friss pedikűr csodákra képes: rendbe hozza a körmöket, puhává
            varázsolja a bőrt, és feltöltött érzést ad. De mi lenne, ha a
            pedikűröt nem csak esztétikai kezelésnek, hanem egy igazi
            egészségügyi ritualének tekintenénk? Amikor a precíz pedikűr
            mesterség összekapcsolódik a masszázs gyógyító erejével, az eredmény
            egy teljes körű wellness élmény, amely a lábfejtől az egész testig
            hat.
          </p>
          <h2>1. Miért fontos a lábmasszázs? A lábfejed a tested térképe</h2>
          <p>
            A lábfejeden rengeteg akupunktúrás pont és idegvégződés található,
            amelyek a tested különböző szerveihez és rendszereihez kapcsolódnak.
            Ez az alapja a reflexológiának. Egy professzionális lábmasszázs
            nemcsak kellemes elmélyülés:
          </p>
          <ul>
            <li>
              <strong>Feszültségoldás:</strong> A talpizmok és a vádli
              folyamatosan dolgoznak. A masszázs enyhíti a merevséget, a
              görcsöket és a fájdalmat.
            </li>
            <li>
              <strong>Javítja a keringést:</strong> Ülőmunka vagy állás? A
              masszázs serkenti a vér- és nyirokkeringést, csökkenti a
              duzzanatot és frissességet ad.
            </li>
            <li>
              <strong>Stresszcsökkentés:</strong> A lábmasszázs mélyen ellazít,
              csökkenti a stresszhormonokat és elősegíti a nyugalmat.
            </li>
            <li>
              <strong>Detoxikálás:</strong> A jobb nyirokkeringés segít a test
              méreganyagainak eltávolításában.
            </li>
          </ul>

          <h2>2. A tökéletes páros: Gyógypedikűr + Masszázs</h2>
          <div className="row">
            <div className="col-md-6 mb-4">
              <h4>
                Egy minőségi gyógypedikűr nem hagyja ki a masszázst. De mire
                számíthatsz pontosan?
              </h4>
              <ul>
                <li>
                  <strong>Előkészítés és ápolás:</strong> A kezelés a lábak
                  fertőtlenítésével és a bőr előkészítésével kezdődik
                </li>
                <li>
                  <strong>A masszázs fázis – Az élmény csúcsa:</strong> Itt
                  történik a varázslat. A pedikűrös szakember egy speciális,
                  nedvesítő krém segítségével alaposan masszírozza a lábfejed, a
                  sarok környékét, a talp ívét, a vádli izmait és akár a
                  lábszárat is. A mozdulatok célzottak, enyhítik a feszültséget
                  és serkentik a vérkeringést.
                </li>
                <li>
                  <strong>A reflexológia elemei:</strong> Egy tapasztalt
                  szakember ösztönösen nyomással dolgozik olyan pontokon,
                  amelyek a gyomrodnak, a hátadnak vagy akár a fejfájásodnak is
                  jót tehetnek.
                </li>
                <li>
                  <strong>Precíz körmellátás:</strong> A masszázs után, teljesen
                  ellazulva következik a körmök reszelése, formára vágása és a
                  zömök bőr gondozása.
                </li>
                <li>
                  <strong>Lakk vagy zömökápolás:</strong> A kezelést a
                  lakkfelvitel vagy egy intenzív zömökápoló pakolás zárja.
                </li>
              </ul>
            </div>
            <div className="col-md-6 mb-4">
              <h2>
                3. Kiénél válasszam? A professzionális gyógypedikűr előnyei
              </h2>
              <p>
                Egy szalonban végzett gyógypedikűr nem csak a szép körömért
                való. A szakember:
              </p>
              <ul>
                <li>
                  <strong>Higiénikus környezetben</strong> dolgozik, steril
                  eszközökkel.
                </li>
                <li>
                  <strong>Ismeri a lábfej anatómiáját</strong> és a gyakori
                  problémákat (pl. sarkrepedés, letaposott talp).
                </li>
                <li>
                  <strong>Olyan termékeket</strong> használ, amelyek hosszú
                  távon is ápolják a bőrt és a körmöket.
                </li>
                <li>
                  <strong>Gyógyító hatású</strong> krémmekkel és pakolásokkal
                  dolgozik.
                </li>
              </ul>
            </div>
            <div className="col-md-6 mb-4">
              <h2>4. Gyakori kérdések (FAQ)</h2>

              <ul>
                <li>
                  <strong>Milyen gyakran érdemes gyógypedikűrre járni?</strong>{" "}
                </li>
                <p>
                  Ajánlott 4-6 hetente, hogy fenn tudjuk tartani az egészséges
                  állapotot és megelőzzük a problémákat.
                </p>
                <li>
                  <strong>Fájdalmas a masszázs?</strong>
                </li>
                <p>
                  Nem, az élvezetes ellazulásról szól. Azonban ha érzékeny
                  pontokra bukkan a szakember, egy enyhe, kellemes feszülés
                  érzetet tapasztalhatsz, ami a feszült izmok feloldódásának
                  jele.
                </p>
                <li>
                  <strong>Ha érzékeny a bőröm, bevállalhatom?</strong>
                </li>
                <p>
                  Természetesen! A szakember kiválasztja a bőrtípusodnak
                  megfelelő, enyhébb összetevőjű termékeket.
                </p>
              </ul>
              <p>
                Ne feledd, a lábad nap mint nap viseli a tested teljes súlyát,
                és megérdemli a legjobb gondoskodást. Egy masszázssal
                kiegészített gyógypedikűr nem luxus, hanem egy okos befektetés a
                közérzetedbe és egészségedbe. Engedd, hogy a lábad ne csak szép,
                hanem teljesen kipihent és egészséges legyen!
              </p>
              <h3>
                Foglalj időpontot még ma, és éld át a teljes körű lápolás
                élményét!
              </h3>
            </div>
          </div>

          <div className="alert alert-warning mt-4">
            <strong>Fontos:</strong> Cukorbetegeknek és keringési problémásoknak
            4-6 hetente ajánlott.
          </div>
        </>
      ),
    },
  },
  {
    id: "thermal-baths-massage",
    date: "2025-07-30",
    title: {
      hu: "Gyógy‑ és wellness masszázs a budapesti termálfürdőkben",
    },
    content: {
      hu: (
        <>
          <img
            src="/articleImages/thermalbathsszechenyibudapesthd.jpg"
            alt="Masszázs egy budapesti termálfürdőben"
            className="img-fluid rounded mb-4"
          />
          <p className="text-muted mb-4 text-center">
            <small>Budapest híres fürdői – wellness kezelések jegyében</small>
          </p>

          <h2>Miért különlegesek Budapest termálfürdői?</h2>
          <p>
            Budapest több mint 100 termálforrással rendelkezik, és ezek
            egészségügyi szempontból is jelentősek. A Széchenyi, Gellért, Rudas
            és Lukács fürdők nemcsak gyógyvizükről, hanem wellness kezeléseikről
            is híresek.
          </p>

          <h2>Milyen masszázsokat kínálnak a fürdőkben?</h2>
          <ul>
            <li>
              Széchenyi Fürdő: svéd és manager masszázs opciók, akár kombinálva
              szaunával.
            </li>
            <li>
              Gellért Fürdő: klasszikus masszázsok hangulatos, art nouveau
              környezetben.
            </li>
            <li>
              Rudas Fürdő: török hagyományokat idéző, terápiás masszázs
              lehetőségekkel.
            </li>
            <li>
              Lukács Fürdő: gyógyszolgáltatások és reflexológiai masszázs egy
              helyen.
            </li>
          </ul>

          <h2>Kinek ajánlott ez a kombinált élmény?</h2>
          <p>Ez a masszázs–fürdő élmény ideális:</p>
          <ul>
            <li>
              Stresszes életmódot folytatóknak, akik regenerálódni szeretnének
            </li>
            <li>Munka és utazás között feltöltődni vágyóknak</li>
            <li>
              Egészségmegőrzésre vágyóknak, ízületi problémák megelőzésére
            </li>
          </ul>

          <div className="alert alert-info mt-4">
            <strong>Tipp:</strong> A hétköznap reggeli órákban kevesebb a
            turista, nyugodtabb a légkör
          </div>

          <h2>
            Hogyan kapcsolhatod össze a Csillag Masszázs Pedikűr
            szolgáltatásaival?
          </h2>
          <p>
            Bár nem a fürdőben dolgozunk, vendégeink gyakran látogatják a
            termálfürdőket, majd hozzánk térnek be masszázsra vagy
            gyógypedikűrre. Így valóban teljes körű, testi-lelki ellátást
            kapnak.
          </p>
          <ul>
            <li>🕯️ Relaxációs masszázs előzetes fürdőzés után</li>
            <li>
              📍 Foglalás: Delice Éden Szalon vagy háznál Budapest III. kerület
            </li>
            <li>📞 Telefon: +36 70 554 1606</li>
          </ul>
        </>
      ),
    },
  },
];

const BlogPostPage = () => {
  const { id } = useParams();
  const { i18n } = useTranslation();
  const lang = i18n.language;

  const post = blogPosts.find((p) => p.id === id);

  if (!post) {
    return <div className="container mt-5 py-5">Blog post not found.</div>;
  }

  return (
    <div className="container" style={{ paddingTop: "160px" }}>
      <Helmet>
        <title>{post.title[lang]} | Csillag masszázs</title>
        <meta name="description" content={post.title[lang]} />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "BlogPosting",
              "mainEntityOfPage": {
                "@type": "WebPage",
                "@id": "https://janoseszter.com/hu/Blog/medical-pedicure-benefits"
              },
              "headline": "Gyógypedikűr: Több, mint egyszerű lábápolás",
              "description": "A professzionális gyógypedikűr hogyan előzi meg a lábproblémákat és javítja az általános életminőséget.",
              "image": "https://janoseszter.com/images/logo225.png",
              "author": {
                "@type": "Person",
                "name": "János Eszter"
              },
              "publisher": {
                "@type": "Organization",
                "name": "Csillag Masszázs Pedikűr",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://janoseszter.com/images/logo225.png"
                }
              },
              "datePublished": "2025-06-15",
              "dateModified": "2025-06-15"
            }
          `}
        </script>
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "BlogPosting",
              "mainEntityOfPage": {
                "@type": "WebPage",
                "@id": "https://janoseszter.com/hu/Blog/manager-massage-impact"
              },
              "headline": "A munkahelyi masszázsterápia hatása a teljesítményre",
              "description": "A professzionális munkahelyi masszázs hatékonyságnövelő és fizikai megterhelést csökkentő hatása.",
              "image": "https://janoseszter.com/images/logo225.png",
              "author": {
                "@type": "Person",
                "name": "János Eszter"
              },
              "publisher": {
                "@type": "Organization",
                "name": "Csillag Masszázs Pedikűr",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://janoseszter.com/images/logo225.png"
                }
              },
              "datePublished": "2025-06-10",
              "dateModified": "2025-06-10"
            }
          `}
        </script>
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "BlogPosting",
              "mainEntityOfPage": {
                "@type": "WebPage",
                "@id": "https://janoseszter.com/hu/Blog/reflexology-therapy"
              },
              "headline": "Talpreflexológiai kezelés egyensúlyteremtés céljából",
              "description": "Talpreflexológia: a belső egyensúly lábon keresztül",
              "image": "https://janoseszter.com/images/logo225.png",
              "author": {
                "@type": "Person",
                "name": "János Eszter"
              },
              "publisher": {
                "@type": "Organization",
                "name": "Csillag Masszázs Pedikűr",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://janoseszter.com/images/logo225.png"
                }
              },
              "datePublished": "2025-06-29",
              "dateModified": "2025-06-29"
            }
          `}
        </script>
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "BlogPosting",
              "mainEntityOfPage": {
                "@type": "WebPage",
                "@id": "https://janoseszter.com/hu/Blog/lymphatic-massage"
              },
              "headline": "Manuális nyirokdrenázs szakszerű kivitelezése",
              "description": "Nyirokmasszázs: a méregtelenítés természetes útja",
              "image": "https://janoseszter.com/images/logo225.png",
              "author": {
                "@type": "Person",
                "name": "János Eszter"
              },
              "publisher": {
                "@type": "Organization",
                "name": "Csillag Masszázs Pedikűr",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://janoseszter.com/images/logo225.png"
                }
              },
              "datePublished": "2025-06-27",
              "dateModified": "2025-06-27"
            }
          `}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            headline: "Gyógypedikűr – nem csak esztétika, hanem megelőzés is",
            description:
              "A gyógypedikűr segít megelőzni a lábproblémákat, mint a bőrkeményedés, tyúkszem vagy gombás fertőzés. Tudja meg, kinek ajánlott, és mire figyeljen kezelés előtt.",
            image: "https://janoseszter.com/images/logo225.png",
            author: {
              "@type": "Person",
              name: "János Eszter",
            },
            publisher: {
              "@type": "Organization",
              name: "Csillag Masszázs Pedikűr",
              logo: {
                "@type": "ImageObject",
                url: "https://janoseszter.com/images/logo225.png",
              },
            },
            datePublished: "2025-06-15",
            dateModified: "2025-07-29",
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id":
                "https://janoseszter.com/hu/Blog/medical-pedicure-benefits",
            },
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            headline: "Gyógy‑ és wellness masszázs a budapesti termálfürdőkben",
            description:
              "Fedezze fel Budapest híres termálfürdőit és masszázs‑kezeléseiket: Széchenyi, Gellért, Rudas, Lukács – hol mit kínálnak, és kiknek érdemes kombinált kezelést választani.",
            image: "https://janoseszter.com/images/thermal-massage.jpg",
            author: {
              "@type": "Person",
              name: "János Eszter",
            },
            publisher: {
              "@type": "Organization",
              name: "Csillag Masszázs Pedikűr",
              logo: {
                "@type": "ImageObject",
                url: "https://janoseszter.com/images/logo225.png",
              },
            },
            datePublished: "2025-07-30",
            dateModified: "2025-07-30",
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id": "https://janoseszter.com/hu/Blog/thermal-baths-massage",
            },
          })}
        </script>
      </Helmet>
      <article className="blog-post">
        <h1 className="mb-3">{post.title[lang]}</h1>
        <p className="text-muted mb-4 ">
          {new Date(post.date).toLocaleDateString(lang, {
            year: "numeric",
            month: "long",
            day: "numeric",
          })}
        </p>
        <div className="blog-content">{post.content[lang]}</div>
      </article>
    </div>
  );
};

export default BlogPostPage;
